<template>
  <div class="breadcrumbs" v-if="selectedGroup || selectedServices.length > 0">
    <div class="group" v-if="selectedGroup">
      <span class="circle" :class="groupClass"></span>
      <span>Обрана група: {{ selectedGroup }}</span>
    </div>
    <div class="services" v-if="selectedServices.length > 0">
      <span>Послуги: </span>
      <span>{{ selectedServices.join(', ') }}</span>
    </div>
  </div>
</template>

<script>
const GROUP_MAPPING = {
  "SW": "СП",
  "PWID": "ЛВНІ",
  "MSM": "ЧСЧ"
};

const SERVICES_MAPPING = {
  "tb_screening": "Скринінг на туберкульоз",
  "ptv": "Тестування на ВІЛ",
  "syringe_exchange": "Обмін шприців",
  "condom_distribution": "Розповсюдження презервативів",
  "information_services": "Інформаційні послуги"
};

export default {
  name: "SiteBreadcrumbs",
  props: {
    group: [String, Object],
    services: Array
  },
  computed: {
    selectedGroup() {
      const value = typeof this.group === 'object' && this.group !== null
        ? this.group.group
        : this.group;
      return GROUP_MAPPING[value] || value || null;
    },
    selectedServices() {
      return this.services.map(service => SERVICES_MAPPING[service] || service);
    },
    groupClass() {
      const group = this.selectedGroup;
      if (group === "ЛВНІ") return "circle-blue";
      if (group === "СП") return "circle-orange";
      if (group === "ЧСЧ") return "circle-white";
      return "";
    }
  },
};
</script>

<style scoped>
.breadcrumbs {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: var(--col-mainblue);
  font-size: 14px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.group {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
}

.services {
  display: flex;
  align-items: flex-start; /* Вирівнює верхній край першого рядка */
  gap: 5px;
}

.services span:first-child {
  flex-shrink: 0; /* Фіксує ширину першого слова ("Послуги:") */
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.circle-blue {
  background-color: #0174f0;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.circle-orange {
  background-color: #faa627;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.circle-white {
  background-color: white;
  border: 1px solid #ccc;
}

</style>
